import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import GoogleAnalytics from "@/components/site/GoogleAnalytics";
import StructuredData from "@/components/site/StructuredData";
import HomePage from "@/pages/HomePage";
import NotFoundPage from "@/pages/NotFoundPage";
import AboutPage from "@/pages/AboutPage";
import ThemesPage from "@/pages/ThemesPage";
import BookingPage from "@/pages/BookingPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App font-body bg-cozy-bg text-cozy-brown">
      <BrowserRouter>
        <Toaster richColors position="top-center" />
        <GoogleAnalytics />
        <StructuredData />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/themes" element={<ThemesPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
